import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './BlogManagementPage.css';

const BlogManagementPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await api.get('/api/blog-posts');
        setPosts(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching blog posts');
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await api.delete(`/api/blog-posts/${id}`);
        setPosts(posts.filter((post) => post._id !== id));
      } catch (err) {
        alert('Error deleting post');
      }
    }
  };

  return (
    <div className="blog-management-container">
      <h1>Manage Blog Posts</h1>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <table className="blog-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Creator</th>
              <th>Last Editor</th>
              <th>Publish Start</th>
              <th>Publish End</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {posts.map((post) => (
              <tr key={post._id}>
                <td>{post.title}</td>
                <td>{post.creator}</td>
                <td>{post.lastEditor}</td>
                <td>{new Date(post.publishStart).toLocaleString('en-CA', { timeZone: 'America/Toronto' })}</td>
                <td>{new Date(post.publishEnd).toLocaleString('en-CA', { timeZone: 'America/Toronto' })}</td>
                <td>
                  <button onClick={() => handleDelete(post._id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BlogManagementPage;
